import { render, staticRenderFns } from "./HelpDetails.vue?vue&type=template&id=476dc22c&scoped=true"
import script from "./HelpDetails.vue?vue&type=script&lang=js"
export * from "./HelpDetails.vue?vue&type=script&lang=js"
import style0 from "./HelpDetails.vue?vue&type=style&index=0&id=476dc22c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476dc22c",
  null
  
)

export default component.exports